export const SET_ACTIVE_MODAL = 'set-active-modal';
export const SET_POPOUT = 'set-popout';
export const CLEAR_HISTORY = 'clear-history';
export const HISTORY_PUSH = 'set-history-push';
export const HISTORY_POP = 'set-history-pop';

